import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { TRENDS_URL } from "./apiEndpoints";
import type { ApiResponse, TrendItem } from "./types";

type UseGetTrendsOptions = Omit<
  UseGetServiceOptions<ApiResponse<TrendItem[]>>,
  "route" | "queryKey"
>;

export const useGetTrends = (options?: UseGetTrendsOptions) =>
  useGetService<ApiResponse<TrendItem[]>>({
    route: TRENDS_URL,
    queryKey: ["dq-dashboard", "trends"],
    retry: false,
    ...(options ?? {}),
  });
